import { Paper, Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import RiskMatrixResultTitle from '../../RiskMatrixResultTitle'

const RiskMatrixResults = ({ riskResult, riskScore }) => {
  const { t } = useTranslation(['common', 'messages'])

  if (!riskResult) {
    return null
  }

  return (
    <>
      <Paper elevation={0} variant="colorPrimary">
        {t('common:riskMatrixResults')}
      </Paper>
      <Paper variant="rootOutlined" elevation={0} sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <RiskMatrixResultTitle riskResult={riskResult} total={riskScore ?? '---'} />
        {riskResult.results?.map((r, idx) => {
          const translateOrValue = (val) => {
            if (!val) return '-';
            const translated = t(`common:${val}`);
            return translated !== `common:${val}` ? translated : val;
          };
          const resultDetails = [
            { label: t('messages:riskmatrix.title.category'), value: translateOrValue(r.category) },
            { label: t('messages:riskmatrix.title.attribute'), value: translateOrValue(r.attribute) },
            { label: t('messages:riskmatrix.title.operator'), value: translateOrValue(r.operator) },
            { label: t('messages:riskmatrix.title.isHit'), value: r.isHit ? t('common:yes') : t('common:no') },
            { label: t('messages:riskmatrix.title.score'), value: typeof r.score === 'number' ? r.score : '-' },
          ]

          return (
            <Box key={idx}>
              <Paper elevation={0}>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '.75rem' }}>
                  {resultDetails.map((detail, detailIdx) => (
                    <div className="c-detail-row" key={detailIdx}>
                      <Typography variant="subtitle1">{detail.label}</Typography>
                      {typeof detail.value === 'string' || typeof detail.value === 'number' ? (
                        <Typography variant="subtitle3">{detail.value}</Typography>
                      ) : (
                        <Typography variant="subtitle3" component="div">
                          {detail.value}
                        </Typography>
                      )}
                    </div>
                  ))}
                </Box>
              </Paper>
            </Box>
          )
        })}
      </Paper>
    </>
  )
}

export default RiskMatrixResults
